import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InicioComponent } from './shared/components/inicio/inicio.component';





export const routes: Routes = [

  {
    path: '',
    component: InicioComponent
  },

  {
    path: 'remision',
    loadChildren: () => import("./view/remision/remision.module").then(m => m.RemisionModule)
  },

  {
    path: 'novedad',
    loadChildren: () => import("./view/novedad/novedad.module").then(m => m.NovedadModule)
  },

  {
    path: 'solicitud',
    loadChildren: () => import("./view/no-hospitalario/solicitud/solicitud-nh.routing").then(m => m.SolicitudNhRouting)
  },

  {
    path: 'lineaunica',
    loadChildren: () => import('./view/lineaUnica/lineaUnica.module').then(m => m.LineaUnicaModule)
  },

  {
    path: 'equiposbiomedicos',
    loadChildren: () => import('./view/equipoBiomedico/equipo-biomedico.module').then(m => m.EquipoBiomedicoModule)
  },


  {
    path: 'informes',
    children: [
      {
        path: '',
        loadChildren: () => import('./view/informes/informes.module').then(m => m.InformesModule)
      },
      {
        path: 'no-hospitalarios',
        loadChildren: () => import('./view/no-hospitalario/informes/informes-nh.routes').then(m => m.informesNhRoutes)
      }
    ]

  },


  {
    path: 'recaudo',
    loadChildren: () => import('./view/no-hospitalario/pagos/pagos.routes').then(m => m.pagosRoutes)
  },


];


@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
